import classnames from 'classnames';
import React, { FunctionComponent, MouseEvent } from 'react';

import { PrimaryButton, TextWarningButton } from '@components/library/button';

import classes from './form_dialog.module.scss';

interface FormDialogButtonsProps {
    creating?: boolean;
    deleting?: boolean;
    disabled?: boolean;
    handleCreate?: (e?: MouseEvent<HTMLButtonElement>) => Promise<void>;
    handleDelete?: (e?: MouseEvent<HTMLButtonElement>) => Promise<void>;
    handleUpdate?: (e?: MouseEvent<HTMLButtonElement>) => Promise<void>;
    updating?: boolean;
}

/**
 * A custom form helper for handling create, delete, and update button display.
 * You should pass in at least one of handleCreate, handleDelete, or handleUpdate.
 * @param {FormDialogButtonsProps} props FormDialogButtonsProps
 */
export const FormDialogButtons: FunctionComponent<FormDialogButtonsProps> = (props) => {
  const { creating, deleting, disabled, handleCreate, handleDelete, handleUpdate, updating } = props;

  return (
    <div className={classes["form-dialog--buttons"]}>
      {(handleDelete || handleUpdate) && (
        <div
          className={classnames(
            classes["form-dialog--delete-update"],
            classes[`form-dialog--delete-update__${(handleDelete && handleUpdate) ? 'both-buttons' : 'one-button'}`]
          )}
        >
          {handleDelete && (
            <TextWarningButton
              disabled={disabled || updating}
              icon="bff-trash"
              isLoading={deleting}
              onClick={handleDelete}
            >
              {deleting ? bfTranslate("Deleting...") : bfTranslate("Delete")}
            </TextWarningButton>
          )}
          {handleUpdate && (
          <PrimaryButton
            disabled={deleting || disabled}
            isLoading={updating}
            onClick={handleUpdate}
            size="small"
          >
            {updating ? bfTranslate("Saving...") : bfTranslate("Update")}
          </PrimaryButton>
          )}
        </div>
      )}
      {handleCreate && (
        <PrimaryButton
          disabled={disabled}
          isLoading={creating}
          onClick={handleCreate}
          size="small"
        >
            {creating ? bfTranslate("Saving...") : bfTranslate("Create")}
        </PrimaryButton>
      )}
    </div>
  );
};
